import { useCallback } from "react";
import { useAppConfig } from "../context/AppConfigContext";
import { useGetUserClaimsOkta } from "./useGetUserClaimsOkta";

export const useHasAccessPermission = () => {
  const userInfo = useGetUserClaimsOkta();
  const roles = userInfo?.pepappwsproles ?? null;
  const { appConfig } = useAppConfig();

  const getRolesFromConfig = useCallback((config, key) => {
    const [firstProp, ...restProps] = key.split(".");

    // Handle array elements by key name
    if (Array.isArray(config)) {
      // Find the array item with matching key
      const matchingItem = config.find((item) => item.key === firstProp);
      if (matchingItem) {
        return restProps.length === 0
          ? matchingItem.roles
          : getRolesFromConfig(matchingItem, restProps.join("."));
      }
      return undefined;
    }

    // Handle object properties
    if (config && typeof config === "object" && firstProp in config) {
      return restProps.length === 0
        ? config[firstProp]?.roles
        : getRolesFromConfig(config[firstProp], restProps.join("."));
    }

    return undefined;
  }, []);

  const hasAccess = useCallback(
    (key) => {
      const requiredAccess = getRolesFromConfig(appConfig, key) || [];

      if (requiredAccess.includes("all")) return true;

      if (roles === null || !Array.isArray(roles)) return false;

      return requiredAccess.some((access) => roles.includes(access));
    },
    [getRolesFromConfig, roles, appConfig]
  );

  return hasAccess;
};
